import type { LevelValue } from '../types';

interface IProps {
  value: string;
  level: LevelValue;
}

const checkMetricWithLevel = ({ value, level }: IProps) => {
  if (level !== 'campaign' && value === 'active_adsets_count') {
    return false;
  }
  if (level !== 'adset' && value === 'active_ads_count') {
    return false;
  }

  return true;
};

export default checkMetricWithLevel;
